(() => {
  if (window.__flairfitPdpV3Loaded) return;
  window.__flairfitPdpV3Loaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const revealObserver = 'IntersectionObserver' in window && !reducedMotion.matches
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 })
    : null;

  const setupReveals = (section) => {
    section.classList.add('ff-motion-ready');
    section.querySelectorAll('[data-ff-reveal]').forEach((element) => {
      if (!revealObserver) {
        element.classList.add('is-visible');
        return;
      }
      revealObserver.observe(element);
    });
  };

  const setupRail = (section) => {
    const rail = section.querySelector('[data-ff-rail]');
    if (!rail) return;

    const previous = section.querySelector('[data-ff-arrow="prev"]');
    const next = section.querySelector('[data-ff-arrow="next"]');
    if (!previous || !next) return;

    const updateControls = () => {
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= maxScroll - 2;
    };

    const move = (direction) => {
      const firstCard = rail.querySelector('[data-ff-rail-card]');
      const styles = getComputedStyle(rail);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : rail.clientWidth * 0.85;
      rail.scrollBy({ left: direction * distance, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    requestAnimationFrame(updateControls);
  };

  const setupFaq = (section) => {
    const faq = section.querySelector('[data-ff-faq]');
    if (!faq) return;

    faq.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        faq.querySelectorAll('details[open]').forEach((sibling) => {
          if (sibling !== details) sibling.removeAttribute('open');
        });
      });
    });
  };

  const setupReturnToBuy = (section) => {
    const button = section.querySelector('[data-ff-return-buy]');
    if (!button) return;

    button.addEventListener('click', () => {
      const form = document.querySelector(
        '.product__meta .product-form, .product__meta form[action*="/cart/add"], [data-product-form], form[action*="/cart/add"]'
      );
      const target = form ? (form.closest('.product__meta') || form) : document.querySelector('main');
      if (!target) return;

      target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
      window.setTimeout(() => {
        const submit = form && form.querySelector('button[type="submit"], input[type="submit"]');
        if (submit) submit.focus({ preventScroll: true });
      }, reducedMotion.matches ? 0 : 650);
    });
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-ff-pdp]:not([data-ff-initialized])').forEach((section) => {
      section.setAttribute('data-ff-initialized', 'true');
      setupReveals(section);
      setupRail(section);
      setupFaq(section);
      setupReturnToBuy(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
